import React, { createContext, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const FilterSupplierContext = createContext();

const FilterSupplierContextProvider = (props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [filterFrom, setFilterFrom] = useState(() => {
    const val = searchParams.get('dateApprovedFrom');
    return val ? new Date(val) : '';
  });
  const [filterTo, setFilterTo] = useState(() => {
    const val = searchParams.get('dateApprovedTo');
    return val ? new Date(val) : '';
  });
  const [from, setFrom] = useState(() => {
    const val = searchParams.get('dateApprovedFrom');
    return val ? new Date(val) : '';
  });
  const [to, setTo] = useState(() => {
    const val = searchParams.get('dateApprovedTo');
    return val ? new Date(val) : '';
  });
  const [filterPaymentDetailsApprovedStatus, setPaymentDetailsApprovedStatus] = useState(
    () => {
      const val = searchParams.get('paymentDetailsApproved');
      return val || 'none';
    }
  );
  return (
    <FilterSupplierContext.Provider
      value={{
        filterFrom,
        setFilterFrom,
        filterTo,
        setFilterTo,
        from,
        setFrom,
        to,
        setTo,
        filterPaymentDetailsApprovedStatus,
        setPaymentDetailsApprovedStatus,
      }}
    >
      {props.children}
    </FilterSupplierContext.Provider>
  );
};

export default FilterSupplierContextProvider;
